// This module MUST be the first main.tsx import. Its small diagnostic dependency
// protects production framework/native sinks before any app import side effects.
import './releaseDiagnostics'
// Capture/remove OAuth parameters before app imports initialize observability.
export const isQuestradeReturn = window.location.pathname === '/finance/questrade/callback'
type Receipt = { code: string; state: string; redirectUri: string }
let pending: Receipt | null = null
let capturedAt = 0
if (isQuestradeReturn) {
 const url = new URL(window.location.href)
 history.replaceState(null, '', url.pathname)
 const code = url.searchParams.get('code'); const state = url.searchParams.get('state')
 if (!url.hash && [...url.searchParams.keys()].sort().join(',') === 'code,state'
  && code && code.length <= 2048 && !/[\r\n]/.test(code) && state && /^[A-Za-z0-9_-]{43}$/.test(state)) {
  pending = { code, state, redirectUri: url.origin + url.pathname }; capturedAt = Date.now()
 }
}
export function takeQuestradeReturn(): Receipt | null {
 const value = pending; pending = null
 return Date.now() - capturedAt <= 600000 ? value : null
}
export function discardQuestradeReturn() { pending = null }
